import React from 'react';

import SelectSearchableDropdown, {
  SelectSearchableDropdownMenuProps,
  SelectSearchableDropdownProps,
} from './SelectSearchableDropdown';

export interface MultiSelectSearchableDropdownProps extends SelectSearchableDropdownProps {
  menuProps?: Omit<SelectSearchableDropdownMenuProps, 'isMulti'>;
}

export default function MultiSelectSearchableDropdown(
  props: MultiSelectSearchableDropdownProps
): JSX.Element {
  return <SelectSearchableDropdown {...props} menuProps={{...props.menuProps, isMulti: true}} />;
}
